import { Outlet } from 'react-router-dom'

import { Auth, StoreUser } from 'Components/Layout'
import { Lazy } from 'Components/Loader'

import Password from 'Components/FormGroup/Password'

const store_user = [
    {
        path: 'store_user',
        element: <Auth guard="store_user" />,
        children: [
            { path: 'verify-email', element: <Lazy view="Auth/VerifyEmail" /> },
            { path: 'verify-email/:id/:hash', element: <Lazy view="Auth/VerifyEmail" /> },
        ],
    },
    {
        path: 'store_user',
        element: <StoreUser guard="store_user" />,
        children: [
            { path: '', element: <Lazy view="StoreUser/Dashboard" /> },
            { path: 'profile', element: <Lazy view="StoreUser/Dashboard/Profile" /> },
            { path: 'password', element: <Password /> },

            {
                path: 'roles',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="StoreUser/Roles/List" /> },
                    { path: 'create', element: <Lazy view="StoreUser/Roles/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="StoreUser/Roles/Create" title="Edit" /> },
                ],
            },
            {
                path: 'store-users',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="StoreUser/StoreUsers/List" /> },
                    { path: 'create', element: <Lazy view="StoreUser/StoreUsers/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="StoreUser/StoreUsers/Create" title="Edit" /> },
                ],
            },
            {
                path: 'bank-accounts',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="StoreUser/BankAccounts/List" /> },
                    { path: 'create', element: <Lazy view="StoreUser/BankAccounts/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="StoreUser/BankAccounts/Create" title="Edit" /> },
                ],
            },
            {
                path: 'bank-transactions',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="StoreUser/BankTransactions/List" /> },
                    { path: 'create', element: <Lazy view="StoreUser/BankTransactions/Create" title="Add new" /> },
                ],
            },
            {
                path: 'wallet-transactions',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="StoreUser/WalletTransactions/List" /> },
                    { path: 'create', element: <Lazy view="StoreUser/WalletTransactions/Create" title="Add new" /> },
                ],
            },
            {
                path: 'customers',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="StoreUser/Customers/List" /> },
                    { path: 'create', element: <Lazy view="StoreUser/Customers/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="StoreUser/Customers/Create" title="Edit" /> },
                ],
            },
            {
                path: 'vendors',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="StoreUser/Vendors/List" /> },
                    { path: 'create', element: <Lazy view="StoreUser/Vendors/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="StoreUser/Vendors/Create" title="Edit" /> },
                ],
            },
            {
                path: 'products',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="StoreUser/Products/List" /> },
                    { path: 'create', element: <Lazy view="StoreUser/Products/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="StoreUser/Products/Create" title="Edit" /> },
                ],
            },
            {
                path: 'purchases',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="StoreUser/Purchases/List" /> },
                    { path: 'create', element: <Lazy view="StoreUser/Purchases/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="StoreUser/Purchases/Create" title="Edit" /> },
                ],
            },
            {
                path: 'store-orders',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="StoreUser/StoreOrders/List" /> },
                    { path: 'create', element: <Lazy view="StoreUser/StoreOrders/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="StoreUser/StoreOrders/Create" title="Edit" /> },
                ],
            },
            {
                path: 'orders',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="StoreUser/Orders/List" /> },
                    { path: 'create', element: <Lazy view="StoreUser/Orders/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="StoreUser/Orders/Create" title="Edit" /> },
                ],
            },
            {
                path: 'analysis',
                element: <Outlet />,
                children: [
                    { path: 'purchases', element: <Lazy view="StoreUser/Analysis/Purchases" /> },
                    { path: 'store-orders', element: <Lazy view="StoreUser/Analysis/StoreOrders" /> },
                    { path: 'orders', element: <Lazy view="StoreUser/Analysis/Orders" /> },
                ],
            },
        ],
    },
]

export default store_user
